import { AgmCoreModule } from "@agm/core";
import { HttpClientModule } from "@angular/common/http";
import { DatePipe } from '@angular/common';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule  } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { CallNumber } from "@ionic-native/call-number";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { File } from "@ionic-native/file/ngx";
import { Geolocation } from "@ionic-native/geolocation";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { IonicStorageModule } from "@ionic/storage";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { AttendanceAddPage } from "../components/attendancecomponent/attendance_add";
import { AttendanceComponent } from "../components/attendancecomponent/attendancecomponent";
import { GuestAddPage } from "../components/attendancecomponent/guest_add";
import { GuestUpdatePage } from "../components/attendancecomponent/guest_update";
import { ControlMessagesComponentModule } from "../components/controlmessagecomponent/controlmessagecomponent.module";
import { HareComponent } from "../components/harecomponent/harecomponent";
import { HeadercomponentModule } from "../components/headercomponent/headercomponent.module";
import { ListComponent } from "../components/listcomponent/listcomponent";
import { PaymentComponent } from "../components/paymentcomponent/paymentcomponent";
import { PledgeComponent } from "../components/pledgecomponent/pledgecomponent";
import { SearchComponent } from "../components/searchcomponent/searchcomponent";
import { SubMenuComponent } from "../components/submenucomponent/submenucomponent";
import { ModalModule } from "../modals/modals.module";
import { CommitteePage } from "../pages/committee/committee";
import { CommitteeAddPage } from "../pages/committee/committee_add";
import { CommitteeUpdatePage } from "../pages/committee/committee_update";
import { CommitteeMemberAddPage } from "../pages/committee/committeemember_add";
import { CommitteeMemberUpdatePage } from "../pages/committee/committeemember_update";
import { ExpensesPage } from "../pages/expenses/expenses";
import { ExpensesAddPage } from "../pages/expenses/expenses_add";
import { ExpensesUpdatePage } from "../pages/expenses/expenses_update";
import { HarelinePage } from "../pages/hareline/hareline";
import { HarelineAddPage } from "../pages/hareline/hareline_add";
import { HarelineUpdatePage } from "../pages/hareline/hareline_update";
import { HarelineViewPage } from "../pages/hareline/hareline_view";
import { HomePage } from "../pages/home/home";
import { LoginPage } from "../pages/login/login";
import { MemberPage } from "../pages/member/member";
import { MemberAddPage } from "../pages/member/member_add";
import { MemberPopover } from "../pages/member/member_popover";
import { MemberUpdatePage } from "../pages/member/member_update";
import { MemberViewPage } from "../pages/member/member_view";
import { OnhomePage } from "../pages/onhome/onhome";
import { PaymentPage } from "../pages/payment/payment";
import { PaymentAddPage } from "../pages/payment/payment_add";
import { PaymentUpdatePage } from "../pages/payment/payment_update";
import { PaymentViewPage } from "../pages/payment/payment_view";
import { PledgePage } from "../pages/pledge/pledge";
import { PledgeAddPage } from "../pages/pledge/pledge_add";
import { PledgeUpdatePage } from "../pages/pledge/pledge_update";
import { RatingPage } from "../pages/rating/rating";
import { ResetpwdLinkPage } from "../pages/resetpwd/resetpwdLink";
import { RouterModule } from '@angular/router';
import { RunCountPage } from "../pages/runcount/runcount";
import { SettingsPage } from "../pages/settings/settings";
import { SettingsAddPage } from "../pages/settings/settings_add";
import { SettingsUpdatePage } from "../pages/settings/settings_update";
import { Sh3Page } from "../pages/sh3/sh3";
import { DashPage } from "../pages/dash/dash";
import { UploadPage } from "../pages/upload/upload";
import { SongsPage } from "../pages/songs/songs";
import { SongsAddPage } from "../pages/songs/songs_add";
import { SongsUpdatePage } from "../pages/songs/songs_update";
import { SongsViewPage } from "../pages/songs/songs_view";
import { TrackingPage } from "../pages/tracking/tracking";
import { AuthService } from "../providers/dbservice/authservice";
import { ConfigService } from "../providers/dbservice/configservice";
import { DbserviceProvider } from "../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../providers/dbservice/validationservice";
import {ExportData} from "../services/export-data";
import { initConfig } from "./app.component";
import { SH3 } from "./app.component";

// GOOGLE MAP  Settings
export const googlemapConfig = {
  apiKey: "AIzaSyCnkQx0REebFJQyc1x6RvqGUJC6blMTXAc"
};

@NgModule({
  declarations: [
    SH3,
    HomePage,
    Sh3Page,
    DashPage,
    UploadPage,
    CommitteePage, CommitteeAddPage, CommitteeUpdatePage,
    CommitteeMemberUpdatePage, CommitteeMemberAddPage,
    GuestAddPage,GuestUpdatePage,
    OnhomePage,
    MemberPage, MemberAddPage, MemberPopover, MemberViewPage, MemberUpdatePage,
    PledgePage, PledgeAddPage, PledgeUpdatePage,
    PaymentPage, PaymentAddPage, PaymentViewPage, PaymentUpdatePage,RunCountPage,
    HarelinePage, HarelineAddPage, HarelineViewPage, HarelineUpdatePage,
    ExpensesPage, ExpensesAddPage, ExpensesUpdatePage,
    SettingsPage, SettingsAddPage, SettingsUpdatePage,
    SongsPage, SongsAddPage, SongsUpdatePage, SongsViewPage,
    RatingPage,TrackingPage,
    LoginPage, ResetpwdLinkPage,
    PledgeComponent, SubMenuComponent,
    AttendanceComponent,
    PaymentComponent,
    SearchComponent, ListComponent, HareComponent, AttendanceAddPage,

  ],
  imports: [
    BrowserModule, HttpClientModule,
    ReactiveFormsModule,
    IonicModule.forRoot(SH3),
    FormsModule,
    IonicStorageModule.forRoot(),
    AgmCoreModule.forRoot(googlemapConfig),
    HeadercomponentModule, ControlMessagesComponentModule,
    RouterModule.forRoot([
      { path: 'pages/member', component: MemberPage },
      { path: 'PaymentPage', component: PaymentPage },
      ]),
  ],
  exports: [HeadercomponentModule, ControlMessagesComponentModule, SubMenuComponent, TrackingPage],

  bootstrap: [IonicApp],
  entryComponents: [
    SH3,
    HomePage,
    Sh3Page,
    DashPage,
    UploadPage,
    CommitteePage, CommitteeAddPage, CommitteeUpdatePage,
    CommitteeMemberUpdatePage, CommitteeMemberAddPage,
    OnhomePage,
    GuestAddPage,GuestUpdatePage,
    MemberPage, MemberAddPage, MemberPopover, MemberViewPage, MemberUpdatePage,
    PledgePage, PledgeAddPage, PledgeUpdatePage,
    PaymentPage, PaymentAddPage, PaymentViewPage, PaymentUpdatePage,RunCountPage,
    HarelinePage, HarelineAddPage, HarelineViewPage, HarelineUpdatePage,
    ExpensesPage, ExpensesAddPage, ExpensesUpdatePage,
    SettingsPage, SettingsAddPage, SettingsUpdatePage,
    SongsPage, SongsAddPage, SongsUpdatePage, SongsViewPage,
    RatingPage,TrackingPage,
    LoginPage, ResetpwdLinkPage,
    SearchComponent, ListComponent, HareComponent, PaymentComponent, AttendanceAddPage,SubMenuComponent,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    Geolocation,
    File,
    ExportData,
    CallNumber,
    DatePipe,
    Camera,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigService],
      multi: true
    },
    DbserviceProvider, ConfigService,
    AuthService,

  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts